<template>
  <div>
    <div class="exam_result">
      <h3>{{examResult.paperTitle}}</h3>
      <div class="w1200 wrap">
        <!--本次得分-->
        <div class="w510 col_1 exam_result_bcdf">
          <h3><span>本次得分</span></h3>
          <div class="con_tongji" id="con_tongji" :style="{width: '300px', height: '300px', padding: '0', margin: '0 auto'}"></div>
        </div>
        <!--/本次得分-->
        <!--本次答题情况-->
        <div class="w670 col_2 exam_result_tdqk">
          <h3><span>本次答题情况</span></h3>
          <div class="dt_list">
            <p v-for="item in resultList" :key="item.id"><i :class="{'dui': item.isCorrect=='1', 'cuo': item.isCorrect=='0'}"></i>{{item.questionTitle}}
              <a v-if="!noAnalysis" href="javascript:;" @click="viewQDetail(examResult.paperId, examId, item.id)">查看解析</a>
            </p>
          </div>
        </div>
        <!--/本次答题情况-->
        <div class="clear"></div>
        <!--数据总揽-->
        <div class="w1200 exam_result_zonglan" :style="{width: '1160px', padding: '20px'}" id="exam_result_zonglan">
        </div>
        <!--/数据总揽-->
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<script>
  // 引入基本模板
  let echarts = require('echarts/lib/echarts')
  // 引入柱状图组件
  require('echarts/lib/chart/bar')
  // 引入仪表盘组件
  require('echarts/lib/chart/gauge')
  // 引入提示框和title组件
  require('echarts/lib/component/tooltip')
  require('echarts/lib/component/title')
  export default {
    components: { },
    props: ['path', 'noAnalysis'],
    data () {
      return {
        examId: this.$route.params.examId,
        examResult: {},
        resultList: []
      }
    },
    created () {
      this.getExamResult(this.examId)
      this.getExamResultList(this.examId)
    },
    mounted () {
    },
    computed: {},
    methods: {
      getExamResult (examId) {
        this.$api.post(this.$global.examApiPath, '/examExamScore/getPaperResult', {id: examId}, r => {
          if (r.data) {
            this.examResult = r.data
            this.drawGauge(this.examResult.passLine, this.examResult.paperScore, this.examResult.score)
            this.drawLine(this.examResult)
          }
        })
      },
      getExamResultList (examId) {
        this.$api.post(this.$global.examApiPath, '/examExamScoreInfo/search', {examId: examId}, r => {
          if (r.data) {
            this.resultList = r.data
          }
        })
      },
      drawGauge (passLine, examScore, userScore) {
        // 基于准备好的dom，初始化echarts实例
        let myChart = echarts.init(document.getElementById('con_tongji'))
        // 绘制图表
        let option = {
          tooltip: {
            formatter: "{a} <br/>{b} : {c}"
          },
          toolbox: {
            show: true,
            feature: {
              mark: {show: true},
              restore: {show: true},
              saveAsImage: {show: true}
            }
          },
          series: [
            {
              name: '试卷得分',
              type: 'gauge',
              max: examScore,
              splitNumber: 10,       // 分割段数，默认为5
              axisLine: {            // 坐标轴线
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: [[passLine/examScore, '#ff4500'], [1, '#48b']],
                  width: 8
                }
              },
              axisTick: {            // 坐标轴小标记
                splitNumber: 10,   // 每份split细分多少段
                length: 12,        // 属性length控制线长
                lineStyle: {       // 属性lineStyle控制线条样式
                  color: 'auto'
                }
              },
              detail: {formatter: '{value}'},
              data: [{value: userScore, name: '得分'}]
            }
          ]
        };
        myChart.setOption(option);
      },
      drawLine (res) {
        let myChart = echarts.init(document.getElementById('exam_result_zonglan'))
        let option = {
          title: {
            text: '数据总览'
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['当前用户', '所有用户']
          },
          toolbox: {
            show: true,
            feature: {
              mark: {show: true},
              dataView: {show: true, readOnly: false},
              magicType: {show: true, type: ['line', 'bar']},
              restore: {show: true},
              saveAsImage: {show: true}
            }
          },
          color: ['#ff4500', '#48b'],
          calculable: true,
          xAxis: [
            {
              type: 'category',
              data: ['平均得分', '平均正确率', '平均用时(分钟)', '总完成次数']
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '当前用户',
              type: 'bar',
              barWidth: 35,
              data: [res.score, res.accuracy*100, parseFloat(res.testDate/60).toFixed(2), res.userAvgTest]
            },
            {
              name: '所有用户',
              type: 'bar',
              barWidth: 35,
              data: [res.allAvgScore, res.allAvgAccuracy*100, parseFloat(res.allAvgTime/60).toFixed(2), res.allMaxTest]
            }
          ]
        };
        myChart.setOption(option);
      },
      viewQDetail (paperId, examId, infoId) {
        this.$router.push({path: this.path + '/examAnalysis/' + paperId + '/' + examId + '/' + infoId})
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/modules/exam/result.vue